import { mapGetters } from 'vuex'
import _ from 'lodash'
import {TweenMax, Power0} from 'gsap'
import ScrollToPlugin from '../vendor/ScrollToPlugin'

export default (options) => {
  let components = {}
  if (_.isObject(options.components)) _.extend(components, options.components)

  return {
    props: {
      // The non-html title attribute, used to display in other components
      title: {
        type: String
      },
      // The theme attribute, tells other components the color; can be 'light', 'dark' or undefined
      theme: {
        type: String,
        default: 'dark',
        validator: function (value) {
          return value === 'light' || value === 'dark' || value === '' || value === undefined
        }
      },
      navtheme: {
        type: String,
        default: 'dark',
        validator: function (value) {
          return value === 'light' || value === 'dark' || value === '' || value === undefined
        }
      },
      logotheme: {
        type: String,        
        validator: function (value) {
          return value === 'light' || value === 'dark' || value === '' || value === undefined
        }
      }
    },
    data: () => ({
      id: 0,
      element: null,
      scene: null
    }),
    mounted () {
      this.$store.dispatch('panels/create', {
        title: this.title,
        theme: this.theme || 'dark',
        navtheme: this.navtheme || 'dark',
        logotheme: this.logotheme
      }).then((which) => {
        // returns the 'id' of the newly created panel item
        this.element = this.$el
        this.id = which
        this.testposition(this.scrollposition)
      })
    },
    watch: {
      scrollposition (position) {
        this.testposition(position)
      },
      scrolltopanel (which) {
        if (which === this.id) {
          this.setscrollpos()
        }
      },
      mobile (mobile) {
        if (!mobile) {
          this.testposition()
        }
      }
    },
    computed: {
      isfirst () {
        return this.id === 0
      },
      islast () {
        return this.id === this.panels.length - 1
      },
      isactive () {
        return this.active === this.id
      },
      scrollposition () {
        return this.scrollprogress.progress
      },
      almostcomplete () {
        const middle = (this.height() * 1.25)
        const trigger = this.startposition() + middle
        return (!this.mobile && this.scrollposition >= trigger)
      },
      complete () {
        const end = (this.height() * 1.85)
        const trigger = this.startposition() + end
        return (!this.mobile && this.scrollposition >= trigger)
      },
      ...mapGetters({
        panels: 'panels/items',
        scrolltopanel: 'panels/scrolltopanel',
        active: 'panels/active',
        previous: 'panels/previous',
        isfirstactive: 'panels/isfirstactive',
        islastactive: 'panels/islastactive',
        animating: 'panels/animating',
        speed: 'panels/speed',
        scrollprogress: 'viewport/progress',
        mobile: 'viewport/mobile',
        isdevice: 'viewport/isdevice',
        viewheight: 'viewport/height'
      })
    },
    methods: {
      height () {
        return this.element ? this.element.offsetHeight : 0
      },
      startposition () {
        return this.$root.getElPosition(this.element).top
      },
      testposition (position) {
        if (_.isUndefined(this.startposition())) return

        let startposition = this.startposition() - 100

        let inposition = (position >= startposition)

        if (inposition) {
          this.$store.dispatch('panels/activate', this.id)
        } else {
          this.$store.dispatch('panels/deactivate', this.id)
        }
      },
      dynamicclass (prefix) {
        let classes = []
        if (this.isactive) classes.push(prefix + '--active')
        if (!this.islast && this.almostcomplete) classes.push(prefix + '--almost')
        if (!this.islast && this.complete) classes.push(prefix + '--complete')
        if (this.isfirst) classes.push(prefix + '--first')
        if (this.islast) classes.push(prefix + '--last')
        return classes
      },
      setscrollpos () {
        let newY = this.startposition()
        let speed = (this.isdevice) ? 0 : this.$root.speed(newY)
        TweenMax.to(
          window,
          speed,
          {
            scrollTo: {y: newY, autoKill: false},
            ease: Power0.easeNone
          }
        )
      }
    },
    components: components
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/panel.js